import DataMapper from './DataMapper'
import LocationRM from '../responsemodel/LocationRM'
import Location from '../../models/Location'

export default class LocationDataMapper extends DataMapper<LocationRM, Location> {
  map = (rm: LocationRM) => new Location(rm.state, rm.district)
}
